import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CurveSharpIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 20 14"
    >
      <path
        d="M2 12 Q8 12 10 2 Q12 12 18 12"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
      />
    </BaseIcon>
  ),
);

CurveSharpIcon.displayName = 'CurveSharpIcon';
